import React, { useEffect, useState, useContext } from "react";

const StatsSelector = ({ onChange, isStatInX }) => {
  const [stat, setStat] = useState(null);
  useEffect(() => {
    if (onChange) {
      onChange(stat, isStatInX);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stat, onChange]);

  return (
    <div className="option-content">
      <label>Estadistica</label>
      <select
        onChange={(e) => {
          setStat(e.target.value);
        }}
        value={stat}
      >
        <option defaultValue>Selecciona Estadistica</option>
        <option value="PTS">Puntos por partido</option>
        <option value="MINSP">Minutos por partido</option>
        <option value="FTA">Tiros libres lanzados por partido</option>
        <option value="FT">Tiros libres convertidos por partido</option>
        <option value="FTP">Tiros libres %</option>
        <option value="TWOOPA">Dobles lanzados por partido</option>
        <option value="TWOOP">Dobles convertidos por partido</option>
        <option value="TWOOPP">Dobles %</option>
        <option value="THREEPA">Triples lanzados por partido</option>
        <option value="THREEP">Triples convertidos por partido</option>
        <option value="THREEPP">Triples %</option>
        <option value="ORB">Rebotes ofensivos por partido</option>
        <option value="DRB">Rebotes defensivos por partido</option>
        <option value="REB">Rebotes totales por partido</option>
        <option value="ASS">Asistencias por partido</option>
        <option value="TO">Perdidas por partido</option>
        <option value="BLK">Tapas cometidas por partido</option>
        <option value="BLKR">Tapas recibidas por partido</option>
        <option value="FL">Faltas cometidas por partido</option>
        <option value="FLR">Faltas recibidas por partido</option>
        <option value="PPP">Puntos Por Posesión</option>
        <option value={"OppPTS"}>Puntos del rival por partido</option>
        <option value="OFE">Eficiencia ofensiva por partido</option>
        <option value="DFE">Eficiencia defensiva por partido</option>
        <option value="NETEFF">Eficiencia neta por partido</option>
        <option value="eFG">Efectividad de tiros de campo por partido</option>
        <option value="OREB">
          Porcentaje de rebotes ofensivos por partido
        </option>
        <option value="FTR">Tasa de tiros libres por partido</option>
        <option value="TOR">Tasa de perdidas por partido</option>
        <option value={"DREB"}>DREB%</option>
        <option value={"POSS"}>Posesiones por partido</option>
        <option value={"ASSR"}>Assistencias por posesiones</option>
        <option value={"TSP"}>Porcentaje de tiro(TS%)</option>
      </select>
    </div>
  );
};

export default StatsSelector;
